module.exports = __webpack_public_path__ + "static/logo@3x-18e6d05452bda92023323c5c68b9f8e0.png";